export default __webpack_public_path__ + "static/media/avatar.c2d76e5f.jpg";